import { createReducer, on } from '@ngrx/store';
import * as PostsActions from './posts.actions';
import { PostsState } from './posts.state';
import { IPost } from '../models/post.model';
import { IShowNewComment } from '../models/showEditComment.model';

export const initialPostsState: PostsState = {
  myPosts: [] as IPost[],
  myFeed: [] as IPost[],
  showNewComment: {} as IShowNewComment,
  showEditComment: false,
  postCreatedOrUpdated: false
};

export const postsReducer = createReducer(
    initialPostsState,

    on( PostsActions.postsActions.getPostsSuccess, (state , { posts }) => ({
      ...state,
      myPosts: posts
    })),

    on( PostsActions.postsActions.getFeedsSuccess, (state , { posts }) => ({
      ...state,
      myFeed: posts
    })),

    on( PostsActions.postsActions.createPostSuccess, (state , { post }) => ({
      ...state,
      myFeed: sortAndFilter(state.myFeed, post),
      myPosts: sortAndFilter(state.myPosts, post),
      postCreatedOrUpdated: true
    })),

    on( PostsActions.postsActions.updatePostSuccess, (state , { post }) => ({
      ...state,
      myFeed: sortAndFilter(state.myFeed, post),
      myPosts: sortAndFilter(state.myPosts, post),
      postCreatedOrUpdated: true
    })),

    on( PostsActions.postsActions.setPostCreatedOrUpdated, (state , { status }) => ({
      ...state,
      postCreatedOrUpdated: status
    })),

    on( PostsActions.postsActions.deletePostSuccess, (state , { postId }) => ({
      ...state,
      myFeed: state.myFeed.filter(x => x.id !== postId),
      myPosts: state.myPosts.filter(x => x.id !== postId)
    })),

    on( PostsActions.postsActions.addCommentSuccess, (state , { post }) => ({
      ...state,
      myFeed: sortAndFilter(state.myFeed, post),
      myPosts: sortAndFilter(state.myPosts, post),
    })),

    on( PostsActions.postsActions.deleteCommentSuccess, (state , { post }) => ({
      ...state,
      myFeed: sortAndFilter(state.myFeed, post),
      myPosts: sortAndFilter(state.myPosts, post),
    })),

    on( PostsActions.postsActions.updateCommentSuccess, (state , { post }) => ({
      ...state,
      myFeed: sortAndFilter(state.myFeed, post),
      myPosts: sortAndFilter(state.myPosts, post),
    })),

    on( PostsActions.postsActions.showNewComment, (state , { id, status }) => ({
      ...state,
      showNewComment: { status,id }
    })),

    on( PostsActions.postsActions.showEditComment, (state , { status }) => ({
      ...state,
      showEditComment: status
    })),

    on( PostsActions.postsActions.clearPosts, (state ) => ({
      ...state,
      myFeed: [],
      myPosts: []
    })),
);

function sortAndFilter(array: IPost[], post: IPost) {
  const filteredArray = array.filter((x) => x.id !== post.id);

  const updatedArray = [...filteredArray, post];

  const sortedArray = updatedArray.sort((a, b) => {
    const dateA = new Date(a.postDate).getTime();
    const dateB = new Date(b.postDate).getTime();

    return dateB - dateA;
  });

  return sortedArray;
}
